<template>
  <div
    class="lang-selector"
    v-if="notSelected"
    @click="changeLocale(notSelected)"
  >
    <img :src="require(`@/assets/img/flags/${notSelected}.svg`)" />
  </div>
</template>

<script>
export default {
  data: () => ({
    items: null
  }),
  computed: {
    notSelected() {
      if (!this.items) {
        return null;
      } else {
        let notSelected = Object.keys(this.items).find(
          e => e != this.$i18n.locale
        );
        if (notSelected.length > 0) {
          return notSelected;
        } else {
          return null;
        }
      }
    }
  },
  mounted() {
    this.items = this.$i18n.messages;
  },
  methods: {
    changeLocale(e) {
      this.$i18n.locale = e;
    }
  }
};
</script>
<style lang="scss" scoped>
.lang-selector {
  height: 100%;
  width: 100%;
  display: flex !important;
  align-items: center;
  justify-content: center;
  img {
    width: 100%;
  }
}
</style>
